export function formatDate(value) {
  return value.toLocaleString("pt-BR", { dateStyle: "short" });
}

export function formatDateTime(value) {
  return value.toLocaleString();
}
